module.exports = __webpack_public_path__ + "static/img/4.24b4ae7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msbl/4.jpg
// module id = N5QD
// module chunks = 1